import React, { useEffect, useState } from 'react'

import styles from './styles.module.scss'
import cn from 'classnames'

import Banner from './Banners/Banner/Banner'
import Products from './Products/Products'
import ProductsSkeleton from './Products/ProductsSkeleton/ProductsSkeleton'
import Form from './Form/Form'
import UnsubscribeForm from '../Popups/UnsubscribeForm/UnsubscribeForm'
import PendingPaymentPopup from '../Popups/PendingPaymentPopup/PendingPaymentPopup'
import PopupNotify from '../Popups/PopupNotify/PopupNotify'
import Spinner from '../../../UI/Spinner/Spinner'

import useServicesStore from './useServicesStore'
import { getPublicStripeKey } from '../../../api/getApi'
import { loadStripe } from '@stripe/stripe-js'
import { notify } from '../../../helpers/notify'
import { Elements } from '@stripe/react-stripe-js'
import ReferralBanner from './Banners/ReferralBanner/ReferralBanner'
import { useSelector, useDispatch } from 'react-redux'
import { setShouldClosePaymentForm } from '../../../redux/billing/billing.action'
import useMediaQuery from '@mui/material/useMediaQuery'
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg'
import { centToDollar } from './utils'

const Services = () => {
  const [sum, setSum] = useState(0)
  const [stripePromise, setStripePromise] = useState(null)

  const [options, setOptions] = useState({
    mode: 'subscription',
    amount: sum > 0 ? sum : (sum + 1) * 100,
    currency: 'usd',
    paymentMethodCreation: 'manual',
    setupFutureUsage: 'off_session',
    appearance: {
      variables: {
        borderRadius: '4px',
      },
    },
  })
  useEffect(() => {
    let isActive = true

    const initStripe = async () => {
      try {
        const { public_key } = await getPublicStripeKey()
        const promise = loadStripe(public_key, { locale: 'en' })

        if (isActive) setStripePromise(promise)
      } catch (error) {
        notify.errorsList(error.errors)
      }
    }

    initStripe()

    return () => {
      isActive = false
    }
  }, [])

  useEffect(() => {
    if (sum > 0) setOptions({ ...options, amount: sum })
    //eslint-disable-next-line
  }, [sum])

  if (!stripePromise) return <Spinner className={styles.storeSpinner} />

  return (
    <Elements stripe={stripePromise} options={options}>
      <ServicesWrapper setSum={setSum} />
    </Elements>
  )
}

const ServicesWrapper = ({ setSum }) => {
  const isDesktop = useMediaQuery('(min-width: 1200px)')
  const [isPaymentFormOpen, setIsPaymentFormOpen] = useState(isDesktop)
  const dispatch = useDispatch()
  const {
    stripe,
    elements,

    card,
    billingDetails,
    products,

    markedUnpaidProductsId,
    markedPaidProductsId,
    unProlongedProducts,
    unsubscribeProduct,
    setMarkedPaidProductsId,
    setUnProlongedProducts,
    updateProductsByEmailSubscription,

    popup,
    successProcessPayment,
    unSuccessProcessPayment,
    serviceEmailSubscription,

    pendingPaymentData,
    setPendingPaymentData,

    filters,
    totalPrice,
    totalPriceForButton,

    loading,
    isPriceLoading,
    isActiveUnsubscribeForm,

    handleSubmit,
    handleCheckBoxClick,
    handleCardDetach,
    handleReadyButtons,

    handlePopupClose,
    handleUnsubscribeFormClose,
    currentProductId,
    paymentRequest,
    paddingBottom,
  } = useServicesStore()

  const referralData = useSelector(({ billing }) => billing.referralData)
  const shouldClosePaymentForm = useSelector(({ billing }) => billing.shouldClosePaymentForm)

  useEffect(() => {
    if (totalPriceForButton > 0) setSum(totalPriceForButton)
  }, [setSum, totalPriceForButton, markedUnpaidProductsId, markedPaidProductsId, isPriceLoading])

  useEffect(() => {
    if (isDesktop) setIsPaymentFormOpen(true)
  }, [isDesktop])

  useEffect(() => {
    const handler = () => setIsPaymentFormOpen(true)
    window.addEventListener('nextship:billing:open-payment-form', handler)
    return () => window.removeEventListener('nextship:billing:open-payment-form', handler)
  }, [])

  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent('nextship:billing:payment-form-state', {
        detail: {
          open: Boolean(isPaymentFormOpen),
          hasCard: Boolean(card?.id),
        },
      })
    )
  }, [isPaymentFormOpen, card?.id])

  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent('nextship:billing:unsubscribe-form-state', {
        detail: { open: Boolean(isActiveUnsubscribeForm) },
      })
    )
  }, [isActiveUnsubscribeForm])

  useEffect(() => {
    const handler = () => {
      if (!card?.id) return
      handleCardDetach()
    }

    window.addEventListener('nextship:billing:detach-card', handler)
    return () => window.removeEventListener('nextship:billing:detach-card', handler)
  }, [card?.id, handleCardDetach])

  return (
    <div className={cn(styles.main, { [styles.slideIn]: !loading })}>
      {/*{!loading && (*/}
      <>
        {/*{referralData && <Banner />}*/}
        <div className={styles.content}>
          <div className={cn(styles.leftBlock, [!referralData && styles.leftBlockColumn])}>
            <div className={styles.bannersBlock}>
              <Banner />
              {referralData && <ReferralBanner />}
            </div>
            {loading ? (
              <ProductsSkeleton />
            ) : (
              <Products
                onCheckBoxClick={handleCheckBoxClick}
                serviceEmailSubscription={serviceEmailSubscription}
                updateProductsByEmailSubscription={updateProductsByEmailSubscription}
                products={products}
                markedPaidIds={markedPaidProductsId}
                markedUnpaidIds={markedUnpaidProductsId}
                unProlongedProducts={unProlongedProducts}
                currentProductId={currentProductId}
                isPriceLoading={isPriceLoading}
              />
            )}
          </div>

          {isDesktop && (
            <Form
              stripe={stripe}
              elements={elements}
              onSubmit={handleSubmit}
              onReady={handleReadyButtons}
              onCardDetach={handleCardDetach}
              countries={filters.countries}
              card={card}
              billingDetails={billingDetails}
              sum={totalPrice}
              markedPaidIds={markedPaidProductsId}
              markedUnpaidIds={markedUnpaidProductsId}
              isLoadingSum={isPriceLoading}
              paymentRequest={paymentRequest}
              paddingBottom={paddingBottom}
              totalPriceForButton={totalPriceForButton}
            />
          )}
        </div>

        {!isDesktop && isPaymentFormOpen && (
          <div className={styles['payment-form__modal']}>
            <div className={styles['payment-form__modal-content']}>
              <button
                type='button'
                className={styles['payment-form__modal-close']}
                onClick={() => setIsPaymentFormOpen(false)}
                aria-label='Close payment form'
              >
                <CloseIcon />
              </button>

              <Form
                stripe={stripe}
                elements={elements}
                onSubmit={handleSubmit}
                onReady={handleReadyButtons}
                onCardDetach={handleCardDetach}
                countries={filters.countries}
                card={card}
                billingDetails={billingDetails}
                sum={totalPrice}
                markedPaidIds={markedPaidProductsId}
                markedUnpaidIds={markedUnpaidProductsId}
                isLoadingSum={isPriceLoading}
                paymentRequest={paymentRequest}
                paddingBottom={paddingBottom}
                totalPriceForButton={totalPriceForButton}
                shouldClosePaymentForm={shouldClosePaymentForm}
                onClosePaymentForm={() => {
                  setIsPaymentFormOpen(false)
                  dispatch(setShouldClosePaymentForm(false))
                }}
              />
            </div>
          </div>
        )}

        {isActiveUnsubscribeForm && (
          <UnsubscribeForm
            reasons={filters.reasons}
            product={unsubscribeProduct}
            successProcessPayment={successProcessPayment}
            unSuccessProcessPayment={unSuccessProcessPayment}
            updateMarkedPaidIds={setMarkedPaidProductsId}
            updateUnProlongedProducts={setUnProlongedProducts}
            onClose={handleUnsubscribeFormClose}
          />
        )}

        {Boolean(pendingPaymentData) && (
          <PendingPaymentPopup
            stripe={stripe}
            data={pendingPaymentData}
            updatePendingPaymentData={setPendingPaymentData}
            successProcessPayment={successProcessPayment}
            unSuccessProcessPayment={unSuccessProcessPayment}
          />
        )}

        {popup.isActive && <PopupNotify onClose={handlePopupClose} {...popup} />}
        {!isDesktop && totalPriceForButton > 0 && (
          <div className={styles['payment-info']}>
            <p className={styles['payment-info__price']}>
              Total <b>${centToDollar(totalPriceForButton)}</b>
            </p>
            <button className={styles['payment-info__button']} onClick={() => setIsPaymentFormOpen(true)}>
              Go to the payment
            </button>
          </div>
        )}
      </>
      {/*)}*/}
    </div>
  )
}

export default Services
